export const MARK_ALL_NOTIFICATIONS_READ = 'MARK_ALL_NOTIFICATIONS_READ';
export const MARK_ALL_NOTIFICATIONS_READ_SUCCESS = 'MARK_ALL_NOTIFICATIONS_READ_SUCCESS';
export const MARK_ALL_NOTIFICATIONS_READ_ERROR = 'MARK_ALL_NOTIFICATIONS_READ_ERROR';

export interface MarkAllNotificationsRead {
  type: typeof MARK_ALL_NOTIFICATIONS_READ;
  payload: null;
}

export interface MarkAllNotificationsReadSuccess {
  type: typeof MARK_ALL_NOTIFICATIONS_READ_SUCCESS;
  payload: null;
}

export interface MarkAllNotificationsReadError {
  type: typeof MARK_ALL_NOTIFICATIONS_READ_ERROR;
  payload: string | boolean;
}

export interface State {
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions = MarkAllNotificationsRead | MarkAllNotificationsReadSuccess | MarkAllNotificationsReadError;
